import { Link } from "react-router-dom";
import styled from "styled-components";

// color: #808080;
export const NavBtnLink = styled(Link)`
  border-radius: 1rem;
  background-color: rgba(0, 0, 0, 0.3);
  color: #000;
  padding: 0.5rem 1.5rem;
  line-height: 2rem;
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  margin-left: 24px;
  &:hover {
    transition: all 0.2s ease-in-out;
    background: #808080;
    color: #fff;
    text-decoration: none;
  }
`;

export const NavBtn = styled.a`
  border-radius: 1rem;
  background: transparent;
  padding: 0.5rem 1.5rem;
  margin: 0.5cm;
  color: #808080;
  outline: 0.5pt grey solid;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  margin-left: 24px;
  &:hover {
    transition: all 0.2s ease-in-out;
    background: #808080;
    color: #fff;
    text-decoration: none;
  }
  position: static;
`;

export const NavBarContainer = styled.div`
  margin: 1rem;
  padding: 1rem 0.5rem 1rem 0.5rem;
  border-bottom: 1pt solid black;
`;

export const NavBarUser = styled.div`
  padding: 0.5rem 1.5rem;
  color: black;
  text-decoration: none;
  margin-left: 24px;
  user-select: none;
  width: fit-content;
  position: absolute;
  right: 20px;
  top: 15px;
`;
